<template>
    <div>
        <DxList
            ref="listRef"
            :data-source="data"
            :search-enabled="true"
            search-mode="contains"
            search-expr="name"
            :min-search-length="2"
            :selection-mode="'single'"
            @item-click="onItemClick"
            @selection-changed="onItemSelected"
            @content-ready="onContentReady"
        >
            <template #item="{ data }">
                <div class="list-item">{{ data.name }}</div>
            </template>
        </DxList>
    </div>
</template>

<script setup>
import { bridge } from '@/views/history/history-card/history-bridge';
import DxList from 'devextreme-vue/list';
import { inject, onMounted, ref } from 'vue';
import { api } from '@/service/http';

let last_selected_id = null;
let selected_id = null;

const data = ref([]);
const listRef = ref(null);
const userData = inject('userData');

onMounted(async () => {
    bridge.updateDogCtxPntList = update;
    bridge.addUpdateControlCallback(setData);
});

const loadData = async parent_id => {
    data.value = await loadForParent(parent_id);
};

const loadForParent = async parent_id => {
    try {
        if (parent_id) {
            const response = await api('core./history/ctx/points/get', { obj_id: parent_id });
            return response.items.map(item => ({ ...item, name: `#${item.num} ${item.name})` }));
        } else {
            return [];
        }
    } catch (error) {
        console.error(`Error on load dogs for dep [${parent_id}]`, error);
        return [];
    }
};

const setData = async changes => {
    selected_id = changes.dog_ctx_pnt_id;
};

const selectItemById = id => {
    if (id) {
        const selectedItem = data.value.find(item => item.id === id);
        listRef.value.instance.selectItem(selectedItem);
    }
};

const onItemClick = x => {
    if (last_selected_id === x.itemData.id) {
        x.component.unselectAll();
        last_selected_id = null;
    } else {
        last_selected_id = x.itemData.id;
    }
};

const onItemSelected = async x => {
    userData.value.dog_ctx_pnt_id = x.addedItems.length > 0 ? x.addedItems[0].id : null;
    // сохранение контекста договора
    bridge.cardCallbacks.onChangeData(userData.value);
    // Сохранение в bridge.changes выбранных значений
    await bridge.onChangePntInDogContext(userData.value.dog_ctx_pnt_id);
};

const update = async obj_id => {
    await loadData(obj_id);
};

const onContentReady = () => {
    if (data.value?.length > 0) {
        selectItemById(selected_id);
    }
};
</script>

<style scoped>
.list-item {
    padding: 10px;
    border-bottom: 1px solid #eee;
}

.list-item:hover {
    background-color: #f5f5f5;
}

.selected-item {
    margin-top: 20px;
    padding: 10px;
    background-color: #e3f2fd;
    border-radius: 4px;
}
</style>
